var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappening(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6918 38.5479C21.3384 40.484 17.2068 40.484 13.8534 38.5479L5.9192 33.9671C2.5658 32.031 0.500026 28.453 0.500025 24.5808L0.500025 15.4192C0.500024 11.547 2.5658 7.96898 5.9192 6.03289L13.8534 1.45207C17.2068 -0.484018 21.3384 -0.484019 24.6918 1.45207L32.626 6.03289C35.9794 7.96898 38.0452 11.547 38.0452 15.4192L38.0452 24.5808C38.0452 28.453 35.9794 32.031 32.626 33.9671L24.6918 38.5479Z",
    fill: "#1890FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.95139 30.4473L15.8856 35.0281C17.9815 36.2381 20.5637 36.2381 22.6596 35.0281L30.5938 30.4473C32.6897 29.2372 33.9808 27.0009 33.9808 24.5808L33.9808 15.4192C33.9808 12.9991 32.6897 10.7628 30.5938 9.55275L22.6596 4.97193C20.5637 3.76187 17.9815 3.76187 15.8856 4.97193L7.95139 9.55275C5.85552 10.7628 4.5644 12.9991 4.56441 15.4192L4.56441 24.5808C4.56441 27.0009 5.85552 29.2372 7.95139 30.4473ZM13.8534 38.5479C17.2068 40.484 21.3384 40.484 24.6918 38.5479L32.626 33.9671C35.9794 32.031 38.0452 28.453 38.0452 24.5808L38.0452 15.4192C38.0452 11.547 35.9794 7.96898 32.626 6.03289L24.6918 1.45207C21.3384 -0.484015 17.2068 -0.484015 13.8534 1.45207L5.9192 6.03289C2.5658 7.96898 0.500024 11.547 0.500025 15.4192L0.500025 24.5808C0.500026 28.453 2.5658 32.031 5.9192 33.9671L13.8534 38.5479Z",
    fill: "#BAE7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4671 10.8379L22.8834 14.8808L27.5959 17.0477L24.9947 21.7133L24.491 27.0954L19.4671 25.9359L14.4433 27.0954L13.9396 21.7133L11.3384 17.0477L16.0509 14.8808L19.4671 10.8379Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappening);
export default __webpack_public_path__ + "static/media/happening.0670e6a380a7172ba0fc541b8178c56c.svg";
export { ForwardRef as ReactComponent };